/**
 * Normalizes playbook key for API calls. Supabase playbook_id has no suffix,
 * but UI may pass keys like "evasys_strategic_priorities_v2:1". Strip any :* suffix.
 */
export function normalizePlaybookKey(playbookKeyRaw: string | null | undefined): string {
  // WARNING: This strips everything after ":"; do NOT use for synthetic event keys like "event::<uuid>".
  return (playbookKeyRaw || '').split(':')[0].trim();
}

/** Path must match `<Route path="/PageName">` casing; query string preserved after `?`. */
export function createPageUrl(pageName: string) {
  const q = pageName.indexOf('?');
  const base = (q >= 0 ? pageName.slice(0, q) : pageName).trim();
  const query = q >= 0 ? pageName.slice(q) : '';
  const pathSeg = base.replace(/ /g, '-');
  return `/${pathSeg}${query}`;
}